<div class="main_header_div">
    <h3 mat-dialog-title class="mat-title"><img class="header-icon mr-3" src="assets/icons/rtf.png">{{data.header}}</h3>
    <div class="pr-3">
        <img class="close-icon" (click)="closeDialog('No')" src="assets/icons/close.png">
    </div> 
</div>
<hr/>
<div>
    <div>
        <p class="paragraph">{{data.text}}</p>
    </div>

  <div>
    <button class="cancel" (click)="closeDialog('No')">No</button>
    <button class="delete" (click)="closeDialog('Yes')">Yes</button>
  </div>
</div>
